import React, { useRef, useEffect } from "react";
import { Modal } from "bootstrap/dist/js/bootstrap.bundle.min.js";
import useLangTranslation from "../../../customHooks/languageProvider";
import { useDispatch, useSelector } from "react-redux";
import {
  setErrorInfo,
  setShowEmailVerification,
  setShowMessage,
} from "../../AxiosRtk/successMessage";
import { againVerifyEmail } from "../../AxiosRtk/Auth";
import useCrypto from "../../../customHooks/crypto";

const EmailVerificationModal = ({ showModal }) => {
  const dispatch = useDispatch();
  const { user } = useSelector(({ auth }) => auth);
  const modalRef = useRef();
  const { getLangTranslation } = useLangTranslation();
  const { encryptRequest } = useCrypto();

  useEffect(() => {
    if (showModal) {
      const modal = new Modal(modalRef.current, {
        backdrop: "static",
        keyboard: false,
      });
      modal.show();
    }
  }, [showModal]);

  const closeModal = () => {
    dispatch(setShowEmailVerification(false));
  };

  const handleSubmit = () => {
    againVerifyEmail(encryptRequest(user?.Email)?.content)
      .then((res) => {
        if (res?.data?.status) {
          closeModal();
          dispatch(
            setShowMessage({
              showMessage: true,
              defaultMessage:
                "A verification email has been sent to your account. Please check your email.",
              message: "AGAIN_SUCCESS_EMAIL",
            })
          );
        }
      })
      .catch((err) => {
        console.log(err);
        closeModal();
        dispatch(
          setErrorInfo({
            errorInfo: true,
            title: "RETRY_AFTER_2_MINUTE",
            defaultTitle: "Please wait 2 minute then resend",
          })
        );
      });
  };
  return (
    <div className="modal fade" tabIndex="-1" ref={modalRef}>
      <div className="modal-dialog modal-dialog-centered modal-sm">
        <div className="modal-content">
          <div className="modal-header border-0 pb-0">
            <h6 className="modal-title text-blue-900">
              Re-sent the verification email
            </h6>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={closeModal}
            ></button>
          </div>
          <div className="modal-body d-flex justify-content-around  text-center">
            <button
              className="btn btn-primary w-100 me-2"
              type="button"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={closeModal}
            >
              <span className="btn-upper-case">
                {getLangTranslation("CANCEL", "Cancel")}
              </span>
            </button>
            <button
              className="btn btn-primary w-100"
              type="button"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={handleSubmit}
            >
              <span className="btn-upper-case">
                {getLangTranslation("VERIFICATION_CODE_BTN_TXT", "Send")}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailVerificationModal;
